import React from 'react'
import HealthcareHerosection from './healthcareHerosection/HealthcareHerosection'
import HealthcareServices from './healthcareService/HealthcareService'
import HealthcareTestimonials from './healthcareTestimonial/HealthcareTestimonials'
import HealthcareDelivery from './healthcareDelivery/HealthcareDelivery'
import HealthcareConsulting from './healthcareConsulting/HealthcareConsultings'
import HealthcareTechnologies from './healthcareTechnology/HealthcareTechnologies'
import HealthcareChoose from './healthcareChoose/HealthcareChoose'

export default function Healthcare() {
  return (
    <div>
        <HealthcareHerosection/>
     <HealthcareConsulting/>
    <HealthcareTechnologies/>
    <HealthcareChoose/>
        <HealthcareDelivery/>
        <HealthcareTestimonials/>
        <HealthcareServices/>
    </div>
  )
}
